import { Injectable } from '@angular/core';
import { CatalogItemObject } from './../../../models/catalog/catalog-item-object.model';
import { Converter } from 'src/app/services/api/converter.interface';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})

export class CatalogItemObjectConverter implements Converter<Map<string, Array<CatalogItemObject>>> {
    mapa = new  Map<string, Array<CatalogItemObject>>();

  convert(input: any): Map<string, Array<CatalogItemObject>> {
    this.mapa = new Map();
    if (isNullOrUndefined(input)) {
      return new Map();
    }

    input.forEach(item => { this.build(item); });
    return this.mapa;
  }


  public build(item: any) {
    let items: Array<CatalogItemObject>;

    if (this.mapa.get(item.name)  === undefined) {
          items = new Array<CatalogItemObject>();
    } else {
        items = this.mapa.get(item.name);
        const itema = new CatalogItemObject(item.name, item.version, item.id);
        if (items.indexOf(itema) === 0) {
            items.push(new CatalogItemObject(item.name, item.version, item.id));
        }
    }
    items.push(new CatalogItemObject(item.name, item.version, item.id));
    this.mapa.set(item.name, items);
  }

}

